import forgotPasswordSlice, {
    ForgotPasswordType,
    InitialForgotPasswordState,
} from './forgotPasswordSlice';

export const {
    setAnswers: setForgotPasswordAnswers,
    setDefaultInitialForgotPasswordState,
} = forgotPasswordSlice.actions;

export {
    type ForgotPasswordType,
    type InitialForgotPasswordState,
};
